var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './StreamOverflow.module.scss';
import { useRouter } from 'src/shared/hooks/useRouting';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { Image } from 'src/ui/components/Image/Image';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { Button, EButtonType } from 'src/ui/components/button/Button';
export var StreamOverflow = function (props) {
    var i18n = props.i18n;
    var router = useRouter();
    var basePath = window.env.BASE_PATH;
    var handleOnClick = function () {
        router.refresh();
    };
    var description = getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.streamOverflow.description');
    var buttonLabel = getPropsByKeyPath(i18n.keyValueMap, 'common.refresh');
    return (_jsxs("div", __assign({ className: styles.caseDetailStreamOverflowWrapper }, { children: [_jsx(Image, { className: styles.caseDetailStreamOverflowIcon, src: "".concat(basePath, "/images/overflowError.svg") }), _jsx("div", __assign({ className: styles.caseDetailStreamOverflowDescriptionWrapper }, { children: _jsx("p", __assign({ className: styles.caseDetailStreamOverflowDescription }, { children: description })) })), _jsx(Button, { type: EButtonType.NEUTRAL, isEdge: true, leftIcon: E_ICONS.REFRESH, label: buttonLabel, onClick: handleOnClick })] })));
};
